const dialogElements = document.querySelectorAll('dialog[id^="dialog-"]');

[...dialogElements].forEach((dialog) => {
    const fullDialogName = dialog.getAttribute('id');
    const dialogName = fullDialogName.replace('dialog-', '');
    const openBtn = document.getElementById(`dialog-${dialogName}-button`);
    const closeBtn = document.querySelector(
        `#dialog-${dialogName} .close-dialog-button`,
    );

    if (!openBtn) return;

    // Open the dialog as a modal
    openBtn.addEventListener('click', () => {
        event.preventDefault();
        if (dialog) {
            const currentVerticalScroll = window.scrollY;
            dialog.showModal();
            document.body.classList.add('js-dialog--active');
            window.scrollTo(0, currentVerticalScroll);
            trapFocus(dialog);
        }
    });

    // Close the dialog
    closeBtn.addEventListener('click', () => {
        dialog.close();
        document.body.classList.remove('js-dialog--active');
    });

    /* Let's add a focus trap function */
    function trapFocus(element) {
        const focusableEls = element.querySelectorAll(
            'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])',
        );
        const firstFocusableEl = focusableEls[0];
        const lastFocusableEl = focusableEls[focusableEls.length - 1];

        function handleKeyDown(e) {
            const isTabPressed = e.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) {
                // Shift + Tab
                if (document.activeElement === firstFocusableEl) {
                    lastFocusableEl.focus();
                    e.preventDefault();
                }
            } else {
                // Tab
                if (document.activeElement === lastFocusableEl) {
                    firstFocusableEl.focus();
                    e.preventDefault();
                }
            }
        }

        element.addEventListener('keydown', handleKeyDown);

        // Optional: Set initial focus to the first focusable element
        if (firstFocusableEl) {
            firstFocusableEl.focus();
        }

        // Return a function to remove the event listener and release the trap
        return () => {
            element.removeEventListener('keydown', handleKeyDown);
        };
    }
});
